import { useProgramCreation } from './ProgramCreationContext';
import { ProgramLaunchPage } from './ProgramLaunchPage';
import { useNavigate } from 'react-router-dom';

export function Step1_SelectType() {
  const { dispatch } = useProgramCreation();
  const navigate = useNavigate();

  return (
    <ProgramLaunchPage
      onPrevious={() => navigate(-1)}
      onSelectMasterclass={() => {
        dispatch({ type: 'SET_PROGRAM_TYPE', payload: 'masterclass' });
        navigate('../masterclass/step-2');
      }}
      onSelectMentorship={() => {
        dispatch({ type: 'RESET_KEEP_PROGRAM_TYPE', payload: { programType: 'mentorship' } });
        dispatch({ type: 'SET_PROGRAM_TYPE', payload: 'mentorship' });
        dispatch({ type: 'SET_BUILD_MODE', payload: 'manual' });
        navigate('../mentorship/program-name');
      }}
      onSelectGuidedMasterclass={() => {
        dispatch({ type: 'SET_PROGRAM_TYPE', payload: 'guided-masterclass' });
        navigate('../guided-masterclass/step-2');
      }}
    />
  );
}
